import React from "react";
import useInput from "@ui/lib/hooks/useInput";
import t from "../../../../../i18n";
import type { ClassificationFailure } from "../../../../../api/useClassificationFailures";

export const useDescriptionInput = (selectedFailures: ClassificationFailure[]) => {
  const hasSameValue = React.useMemo(
    () =>
      selectedFailures.filter(
        failure =>
          "setup" in failure &&
          selectedFailures[0] &&
          "setup" in selectedFailures[0] &&
          failure.description !== selectedFailures[0]?.description,
      ).length === 0,
    [selectedFailures],
  );

  const defaultValue = React.useMemo(() => {
    if (hasSameValue)
      return selectedFailures[0] &&
        "setup" in selectedFailures[0] &&
        selectedFailures[0].description
        ? selectedFailures[0].description
        : undefined;
    return "";
  }, [hasSameValue, selectedFailures]);

  const { value, setValue, onChange, dirty } = useInput(defaultValue);

  const placeholder = React.useMemo(() => {
    if (!hasSameValue) {
      return t("administration.modal.multiple_value");
    }
    if (defaultValue === "") {
      return t("setup.paragraphs.quantities.table.definitions.column.description");
    }
    return defaultValue;
  }, [defaultValue, hasSameValue]);

  return {
    placeholder,
    value,
    setValue,
    onChange,
    dirty,
  };
};
